import { render, staticRenderFns } from "./MultiMessageRooms.vue?vue&type=template&id=686e976f&scoped=true&"
import script from "./MultiMessageRooms.vue?vue&type=script&lang=js&"
export * from "./MultiMessageRooms.vue?vue&type=script&lang=js&"
import style0 from "./MultiMessageRooms.vue?vue&type=style&index=0&id=686e976f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e976f",
  null
  
)

export default component.exports